import http from "../../../http";
import { getParamsFromQuery, sliceObject } from "../xes-lib";

class Handler {
  constructor() {
    this.locked = false
  }
  getMBlockToken() {
    return http.getMBlockToken()
  }
  refreshMBlockToken() {
    return http.refreshMBlockToken()
  }
  isLock() {
    return this.locked
  }
  lock() {
    this.locked = true
  }
  unLock() {
    this.locked = false
  }
  handleLockMethod(cb) {
    if (this.isLock()) {
      return Promise.resolve(null)
    }
    this.lock()
    return cb().then(data => {
      this.unLock()
      return Promise.resolve(data)
    }).catch((err) => {
      this.unLock()
      return Promise.reject(err)
    }).then((data) => {
      return Promise.resolve(data)
    })
  }
  save(params) {
    return http.saveProject(params)
  }
  saveAs () {}
  submit() {}
  share() {}
  check() {}
  saveAs() {}
  publish() {}
  getTemplateData() {
    let params = getParamsFromQuery([
      'template_project_id',
      'work_type'
    ])
    return http.getLiveProject(params)
  }
  init(state, dispatch, data) {}
  getProjectData() {}
}

export default Handler